import styled from 'styles/styled';
import imgAvatar from '../../../assets/icons/IconBull.svg';

/**
 * The identity slot in the nav strip: the bull icon and the player's nickname.
 *
 * `flex-shrink: 0` is the whole point. This box is a flex item next to the
 * sponsor slot, and without it the box was shrunk to the icon's own width —
 * which left `AvatarName` at exactly 0px and `text-overflow: ellipsis` clipping
 * the nickname down to a stray first letter beside the bull. Measured live on
 * production: the slot gave up 37px it did not have to, and the sponsor banner
 * kept its 457px either way, so nothing is taken from the sponsor by refusing
 * to shrink.
 *
 * Bounded to the range where the nickname is actually rendered. Below 1200px it
 * is hidden, so there is nothing to protect, and refusing to shrink there only
 * widens the strip past the screen.
 */
export const NickName = styled.div`
  font-size: 12px;
  font-weight: 700;
  padding-right: 10px;
  color: #EFEFEF;
  margin-left: 24px;
  @media (min-width: 1201px) {
    flex-shrink: 0;
  }
  @media (max-width: 1300px) {
    margin-left: 15px;
  }
  @media (max-width: 720px) {
    display: none;
  }
`;

export const AvatarIcon = styled.div`
  width: 30px;
  height: 30px;
  float: left;
  background-color: ${({ theme }) => theme.palette.darkMedium};
  border-radius: 100%;
  margin-right: 8px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${imgAvatar});
  @media (max-width: 1300px) {
    width: 26px;
    height: 26px;
  }
  @media (max-width: 720px) {
    margin: 0;
    width: 24px;
    height: 24px;
  }
`;

/**
 * The nickname reads in full or not at all — a truncated fragment beside the
 * bull reads as breakage, which is what was reported from the ETHSofia
 * tournament. It hides on the same 1200px line where the sponsor slot swaps its
 * inline label for the small one above the banner, because that is where the
 * strip stops having room for both. Below 720px `NickName` hides the whole
 * identity slot anyway.
 */
export const AvatarName = styled.div`
  margin: 8px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (max-width: 1200px) {
    display: none;
  }
  @media (max-width: 1300px) {
    margin: 7px 0;
  }
  @media (max-width: 720px) {
    margin: 1px 0 0 0;
    max-width: 120px;
  }
`;
